import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

const ReportCell = ({ children, edited, truncate, type }) => (
  <div
    className={classnames({
      'data-truncate': truncate,
      'data-border-double-bottom-line': type === 'DATA_BORDER_DOUBLEBOTTOMLINE',
      'data-border-bottom-line': type === 'DATA_BORDER_BOTTOMLINE',
      'data-edited': edited,
    })}
  >
    {children}
  </div>
);

ReportCell.propTypes = {
  children: PropTypes.node.isRequired,
  edited: PropTypes.bool,
  truncate: PropTypes.bool,
  type: PropTypes.string,
};

ReportCell.defaultProps = {
  edited: false,
  truncate: false,
  type: '',
};

export default ReportCell;
